import React, { useState, useEffect } from "react";
import axios from "axios";

function Repos({ repos_url }) {

  const [repos, setRepos] = useState([]);

  const fetchRepos = async () => {
    const { data } = await axios.get(repos_url);
    setRepos(data);
  };

  useEffect(() => {
    fetchRepos();
  }, [repos_url]);

  return (
    <ul className="list-group">
      {
        repos.map((repo) => (
          <li className="list-group-item">
            <div className="text-primary">{repo.name}</div>
            <div className="text-secondary">{repo.language}</div>
            <div className="text-info">{repo.description}</div>
          </li>)
        )
      }
    </ul>
  )
}

export default Repos
